export default {
  postingGroups: [],
  postBatches: []
}
